var React = require('react');

function ChartArrow (props) {
    return React.createElement("svg",props,React.createElement("path",{"d":"M1.92002 12.68L9.00035 5.8627L14.955 11.5961C15.3944 12.0192 16.1067 12.0192 16.5454 11.5961L24.75 3.69635V9.7486C24.75 10.3444 25.2563 10.8318 25.875 10.8318C26.4938 10.8318 27 10.3444 27 9.7486V1.08318C27 0.48743 26.4938 0 25.875 0H16.9385C16.2565 0 15.7502 0.48743 15.7502 1.08318C15.7502 1.67893 16.2565 2.16636 16.8752 2.16636H23.1596L15.7502 9.30179L9.79487 3.56772C9.35542 3.1446 8.64317 3.1446 8.20443 3.56772L0.329583 11.15C-0.109861 11.5731 -0.109861 12.2589 0.329583 12.6813C0.766919 13.1065 1.48409 13.1065 1.92002 12.68Z","fill":"#2747AB"}));
}

ChartArrow.defaultProps = {"width":"27","height":"13","viewBox":"0 0 27 13","fill":"none"};

module.exports = ChartArrow;

ChartArrow.default = ChartArrow;
